import * as React from 'react';

const SvgChevronSmallDown = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4 10.636L16.9858 9.2218L12.0361 14.1709L7.08633 9.2218L5.67212 10.636L12.0361 17L18.4 10.636Z", fill: "currentColor" }));

export { SvgChevronSmallDown as default };
